import Button from "@mostrans/web-components/components/base/Button";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { Navigation } from "swiper";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { useGetFeaturedJobs } from "../../../GQL/Opportunity/hooks/useGetFeaturedJobs";
import CardFeaturedJobs from "../../../components/Card/Opportunity/CardFeaturedJobs";
import { useModals } from "../../../shared/hooks/useModals";

function FeaturedJobs() {
  const { orderedJobs } = useGetFeaturedJobs();
  const { showModal } = useModals();
  const navigate = useHistory();

  return (
    <section className="bg-jobs">
      <div className="d-flex pt-3 pb-4 flex-column">
        <div className="container d-flex justify-content-center align-items-center text-center">
          <h3>So, beranikah kamu menjadi bagian dari M-TITANS?</h3>
        </div>
        <div className=" p-2" style={{ display: "inline-block" }}>
          <Swiper
            slidesPerView={3}
            spaceBetween={20}
            breakpoints={{
              39: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 3,
              },
            }}
            className="mySwiper"
            navigation={true}
            modules={[Navigation]}
          >
            {orderedJobs.map((job) => (
              <SwiperSlide key={job.id}>
                <CardFeaturedJobs
                  onClick={() =>
                    showModal("detailOpportunity", { oppId: job?.id })
                  }
                  title={job?.title}
                  level={job?.job_level}
                  departement={job?.Division?.division}
                  location={job?.Location?.nama}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="d-flex justify-content-center">
          <Button
            variant="contained"
            onClick={() => navigate.push("/explorejobs")}
            sx={{
              ":hover": {
                boxShadow: "7px 7px rgb(0,0,0)",
              },
            }}
          >
            Jelajahi Lainnya
          </Button>
        </div>
      </div>
    </section>
  );
}

export default FeaturedJobs;
